module.exports = __webpack_public_path__ + "img/GOPR1521.e43e34d1.png";